import { MonitorType } from "@/services/backend/qpm/types/enums";

export const DEFAULT_MONITOR_TYPE_QUERY = "checkpoint" as const;

export type MonitorTypeQuery = "checkpoint" | "flyex" | "iot";

const queryToType: Record<MonitorTypeQuery, MonitorType> = {
  checkpoint: MonitorType.Checkpoint,
  flyex: MonitorType.FlyExterminator,
  iot: MonitorType.IoT,
};

const typeToQuery: Record<MonitorType, MonitorTypeQuery> = {
  [MonitorType.Checkpoint]: "checkpoint",
  [MonitorType.FlyExterminator]: "flyex",
  [MonitorType.IoT]: "iot",
};

export function monitorTypeFromQuery(
  value: string | null | undefined,
): MonitorType | undefined {
  if (!value) return undefined;
  const normalized = value.trim().toLowerCase() as MonitorTypeQuery;
  return queryToType[normalized];
}

export function monitorTypeToQuery(type: MonitorType): MonitorTypeQuery {
  return typeToQuery[type];
}
